<template>
  <div class="pb-3" >
    <va-card :title="$t(`championships.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(upload)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Nome" v-slot="{ errors }">
                <va-input
                  v-model="championship.name"
                  :label="$t('championships.forms.nameLabel')"
                  :placeholder="$t('championships.forms.namePlaceholder')"
                  :success="errors.length === 0 && championship.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <label>{{$t('championships.forms.categoryPlaceholder')}}</label>
              <va-toggle
                v-model="championship.isCategory"
                small
                :label="championship.isCategory ? 'Sim' : 'Não'"
              />
              <div class="form-group">
                <va-select
                  :label="$t('championships.forms.idCategoryLabel')"
                  v-model="idCategory"
                  textBy="name"
                  keyBy='id'
                  no-clear
                  searchable
                  :placeholder="$t('championships.forms.idCategoryPlaceholder')"
                  :noOptionsText="$t('championships.forms.idCategoryNoOption')"
                  maxHeight='200px'
                  :options="category.length > 0 ? category : []"
                />
              </div>
              <label>{{$t('championships.forms.showPlaceholder')}}</label>
              <va-toggle
                v-model="championship.show"
                small
                :label="championship.show ? 'Sim' : 'Não'"
              />
              <label>{{$t('championships.forms.isApiPlaceholder')}}</label>
              <va-toggle
                v-model="championship.isApi"
                small
                :label="championship.isApi ? 'Sim' : 'Não'"
              />
              <div v-if='oldLogo.length > 0' class="form-group mt-3">
                <img
                  :src="$store.getters['environment/cdn'] + '/championships/' + oldLogo"
                  style="height: 30vh; max-width: 100%;"
                >
              </div>
              <ValidationProvider name="Logo" :rules="oldLogo.length > 0 ? '' : 'required'" v-slot="{ errors }">
                <div class="form-group mt-3">
                  <label
                    class="va-input__container__label position"
                    style="color: rgb(108, 127, 238);">
                    {{$t('championships.forms.logoLabel')}}
                  </label>
                  <va-file-upload
                    type="single"
                    v-model="logo"
                  />
                  <ErrorMessages :errors='errors'/>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" name="ID da API" v-slot="{ errors }">
                <va-input
                  v-model="api"
                  :label="$t('championships.forms.idApiLabel')"
                  :placeholder="$t('championships.forms.idApiPlaceholder')"
                  :success="errors.length === 0 && api > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <label>{{$t('championships.forms.isClassificationPlaceholder')}}</label>
              <va-toggle
                v-model="championship.isClassification"
                small
                :label="championship.isClassification ? 'Sim' : 'Não'"
              />
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import ErrorMessages from '../utils/ErrorMessages'
import gql from 'graphql-tag'
export default {
  name: 'ChampionshipsAddUpdate',
  components: { ErrorMessages },
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  computed: {
    api: {
      get () {
        return this.championship.idApi
      },
      set (value) {
        if (value > 0) {
          this.championship.idApi = value
        }
      },
    },
  },
  data () {
    return {
      semCat: {
        id: '',
        name: 'Sem categoria',
      },
      championship: {
        name: '',
        logo: '',
        slug: '',
        show: false,
        isCategory: false,
        idCategory: '',
        isApi: false,
        idApi: 0,
        isClassification: true,
      },
      category: [],
      oldLogo: '',
      idCategory: '',
      logo: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.championship.name = ''
    this.championship.logo = ''
    this.championship.slug = ''
    this.championship.show = ''
    this.championship.isCategory = false
    this.championship.idCategory = ''
    this.championship.isApi = false
    this.championship.idApi = 0
    this.championship.isClassification = true
    if (this.updateData !== null) {
      this.championship_get(this.updateData)
    }
  },
  watch: {
    logo (value) {
      if (value.length > 0) {
        this.championship.logo = value[0].name
      }
    },
    updateData (value) {
      if (this.updateData !== null) {
        this.championship_get(this.updateData)
      } else {
        this.championship.name = ''
        this.championship.logo = ''
        this.championship.isCategory = false
        this.championship.idCategory = ''
        this.championship.isApi = false
        this.championship.idApi = 0
        this.championship.isClassification = true
        this.championship.slug = ''
        this.championship.show = false
      }
    },
    idCategory (value) {
      if (value !== '') {
        this.championship.idCategory = value.id
      }
    },
  },
  methods: {
    slugfy (str) {
      return str.toLowerCase()
        .replace(/[àÀáÁâÂãäÄÅåª]+/g, 'a') // Special Characters #1
        .replace(/[èÈéÉêÊëË]+/g, 'e') // Special Characters #2
        .replace(/[ìÌíÍîÎïÏ]+/g, 'i') // Special Characters #3
        .replace(/[òÒóÓôÔõÕöÖº]+/g, 'o') // Special Characters #4
        .replace(/[ùÙúÚûÛüÜ]+/g, 'u') // Special Characters #5
        .replace(/[ýÝÿŸ]+/g, 'y') // Special Characters #6
        .replace(/[ñÑ]+/g, 'n') // Special Characters #7
        .replace(/[çÇ]+/g, 'c') // Special Characters #8
        .replace(/[ß]+/g, 'ss') // Special Characters #9
        .replace(/[Ææ]+/g, 'ae') // Special Characters #10
        .replace(/[Øøœ]+/g, 'oe') // Special Characters #11
        .replace(/[%]+/g, 'pct') // Special Characters #12
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w-]+/g, '') // Remove all non-word chars
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
    },
    cancel () {
      this.$emit('showAdd', false)
    },
    championship_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          if (value === 'logo') {
            this.oldLogo = data[value]
            this.championship[value] = ''
          } else if (value === 'is_category') {
            this.championship.isCategory = data[value]
          } else if (value === 'category') {
            if (data[value] === null) {
              this.idCategory = this.semCat
            } else {
              this.idCategory = data[value]
            }
          } else if (value === 'is_api') {
            this.championship.isApi = data[value]
          } else if (value === 'id_api') {
            this.championship.idApi = data[value]
          } else if (value === 'is_classification') {
            this.championship.isClassification = data[value]
          } else {
            this.championship[value] = data[value]
          }
        }
      })
    },
    upload () {
      if (this.championship.logo.length !== 0) {
        const formData = new FormData()
        formData.append('file', this.logo[0])
        formData.append('path', 'championships')
        if (this.updateData !== null) {
          formData.append('deleteFile', this.oldLogo)
        }
        this.$axios.post(
          '/api/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(resp => {
          this.championship.logo = resp.data.filename
          this.onSubmit()
        })
      } else {
        this.championship.logo = this.oldLogo
        this.onSubmit()
      }
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      this.championship.slug = this.slugfy(this.championship.name)
      const { name, logo, isCategory, idCategory, isApi, idApi, isClassification, slug, show } = this.championship
      const self = this
      console.log(idCategory)
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($name: String!, $logo: String!, $slug: String!, $is_category: Boolean, $show: Boolean, $id: Int!, $id_api: Int!, $id_category: Int!, $is_api: Boolean!, $is_classification: Boolean!) {
                  update_championship_by_pk(pk_columns: {id: $id}, _set: {name: $name, logo: $logo, slug: $slug, is_category: $is_category, show: $show, id_api: $id_api, id_category: $id_category, is_api: $is_api, is_classification: $is_classification}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($name: String, $logo: String, $slug: String!, $is_category: Boolean, $show: Boolean, $id_api: Int!, $id_category: Int!, $is_api: Boolean!, $is_classification: Boolean!) {
                  insert_championship(objects: {name: $name, logo: $logo, slug: $slug, is_category: $is_category, show: $show, id_api: $id_api, id_category: $id_category, is_api: $is_api, is_classification: $is_classification}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            name,
            logo,
            slug,
            show,
            is_category: isCategory,
            id_category: idCategory === '' ? null : idCategory,
            is_api: isApi,
            id_api: idApi,
            is_classification: isClassification,
            id: this.championship.id,
          } : {
            name,
            logo,
            slug,
            show,
            is_category: isCategory,
            id_category: idCategory === '' ? null : idCategory,
            is_api: isApi,
            id_api: idApi,
            is_classification: isClassification,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.championship.name = ''
          self.championship.logo = ''
          self.championship.slug = ''
          self.championship.show = false
          self.championship.isCategory = false
          self.championship.idCategory = ''
          self.championship.isApi = false
          self.championship.idApi = 0
          self.championship.isClassification = true
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.championship.name = ''
          self.championship.logo = ''
          self.championship.slug = ''
          self.championship.show = false
          self.championship.isCategory = false
          self.championship.idCategory = ''
          self.championship.isApi = false
          self.championship.idApi = 0
          self.championship.isClassification = true
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  apollo: {
    category: {
      query: gql`
      query MyQuery {
        category(where: {active: {_eq: true}}) {
          id
          name
        }
      }
      `,
      manual: true,
      result ({ data, loading }) {
        if (!loading) {
          if (data.category.length > 0) {
            if (data.category[0].id !== this.semCat.id && data.category[0].name !== this.semCat.name) {
              data.category.unshift(this.semCat)
            }
            this.category = data.category
            if (this.idCategory === '') {
              this.idCategory = this.semCat
            }
          }
        }
      },
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
